export default {
  GET_ONE: `#graphql
  query getOneUser($dni: String!) {
    getOneUser(dni: $dni)
    { 
      name
    }            
  }`,

  GET_NAME: `#graphql
  query getNameUser($dni: String!) {
    getNameUser(dni: $dni)
    { 
      name
    }            
  }`,

  GET_WHOLESALER_BY_NAME: `#graphql
  query getWholesalerByName($name: String!) {
    getWholesalerByName(name: $name)
    { 
      dni,
      name,
      phones,
      emails,
      type,
      addresses,
      balance
    }            
  }`,

  GET_ALL: `#graphql
  query getUsers($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getUsers(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        dni,
        name,
        type,
        addresses,
        phones,
        emails,
        alias,
        balance,
        active,
        showInPage
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getUsersHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getUsersHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        dni,
        name,
        type,
        addresses,
        phones,
        emails,
        alias,
        balance,
        active,
        showInPage
        version,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewUser($user: UserInput!) {
    newUser(input: $user)
    {
      dni,
      name,
      type
    }            
  }`,

  NEW_ROOT: `#graphql
  mutation NewUserRoot($user: UserInput!) {
    newUserRoot(input: $user)
    {
      dni,
      name,
      type
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateUser($dni: String!, $userUpdate: UserUpdateInput!) {
    updateUser(dni:$dni, userUpdate: $userUpdate)
    {
      dni,
      name,
      type
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteUser($dni: String!) {
    deleteUser(dni:$dni)
    {
      dni,
      name
    }            
  }`,

  CHARGE_BALANCE: `#graphql
  mutation ChargeBalanceUser($dni: String!, $value: Int!, $add: Boolean!) {
    chargeBalanceUser(dni: $dni, value: $value, add: $add)           
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/user.js